<template>
  <v-card>
    <v-card-title class="cardtitle mb-2 rounded-0">Autopsy and Toxicological Analysis</v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-select
          v-model="newData.carriedOut"
          label="Carried out"
          :items="AutopsyCarriedOut"
          required
          :rules="required"
        />
        <v-text-field 
          v-model="newData.companyName" 
          label="Company name" />
        <v-text-field 
          v-model="newData.autopsyLab" 
          label="Autopsy laboratory" />
        <v-text-field
          v-model="newData.toxicologicalLab"
          label="Toxicological laboratory"
        />
        <v-text-field 
          v-model="newData.vetInCharge" 
          label="Vet in charge" />
        <v-text-field
          v-model="newData.samplesAnalyzed"
          label="Samples analyzed (codes)"
        />

        <v-menu
          v-model="dateOfReportMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateOfReport"
              label="Date of report"
              readonly
              v-on="on"
              outlined
              append-icon="mdi-calendar"
            />
          </template>
          <v-date-picker
            v-model="newData.dateOfReport"
            :locale="locale"
            min="1980-01-01"
            max="2050-01-01"
            @change="setReportDate"
            @input="dateOfReportMenu = false"
          ></v-date-picker>
        </v-menu>

        <v-text-field 
          v-model="newData.reportCode" 
          label="Report code" />
        <v-select 
          v-model="newData.diagnose" 
          label="Diagnose" 
          :items="Diagnose" />
        <v-select
          v-model="newData.numberOfToxin"
          label="Number of toxin"
          :items="NumberOfToxin"
        />
        <v-text-field
          v-model="newData.presenceOfOtherSubstances"
          label="Presence of other substances"
        />
        <v-text-field 
          v-model="newData.otherInfo" 
          label="Other information" />
        <v-text-field 
          v-model="newData.comments" 
          label="Comments" />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="error"
        @click="cancel"
      >Cancel</v-btn>
      <v-btn
        color="grey lighten-2"
        @click="reset"
      >Clear</v-btn>
      <v-btn
        :disabled="!valid || !isDirty"
        color="#7eb09f"
        @click="validate"
      >Save
         <v-progress-circular color="biscuit" v-if="loading" indeterminate/>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import AutopsyToxicolAnalInfo from '@/models/autopsytoxicolanalinfo.js'
import { AutopsyCarriedOut, Diagnose, NumberOfToxin } from '@/utils/selectoptions.js'
import { formatDate, cloneObject } from '@/utils/general.js'
import { DateTime } from 'luxon'

export default {
  props: {
    AutopsyToxicolAnalInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    passed: {
      type: Boolean,
      default: false
    },
    entrycode: {
      type: Number
    }
  },
  data: function () {
    return {
      valid: false,
      loading: false,
      required: [
        v => !!v || 'Field is required'
      ],
      dateOfReport: this.passed ? this.AutopsyToxicolAnalInfo.dateOfReport : "",
      dateOfReportMenu: false,
      AutopsyCarriedOut: AutopsyCarriedOut,
      Diagnose: Diagnose,
      NumberOfToxin: NumberOfToxin
    };
  },
  methods: {
    validate () {
      this.loading = true
      if (this.$refs.form.validate()) {
        this.$store.dispatch('incidentsnew/updAutopsy', {entrycode: this.entrycode, payload: this.newData})
          .then(() => {
            this.loading = false
            this.initData = cloneObject(this.newData)
          })
          .catch(e => {
            console.log(this.$store.state.incidentsnew.error)
            throw(e)
          })  // FIXME
      } else {
        this.loading = false
      }
    },
    cancel () {
      this.$router.back();
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    setReportDate (evt) {
      this.dateOfReport = formatDate(evt)
    }
  },
  created () {
    //this.newData = new AutopsyToxicolAnalInfo()
  },
  mounted () {
    if (this.passed) {
      this.initData = {...this.AutopsyToxicolAnalInfo}
      this.newData =  JSON.parse(JSON.stringify(this.AutopsyToxicolAnalInfo))

      if (this.newData.dateOfReport) {
        this.newData.dateOfReport = DateTime.fromFormat(this.newData.dateOfReport, 'dd/MM/yyyy').toISODate()
        this.initData.dateOfReport = DateTime.fromFormat(this.initData.dateOfReport, 'dd/MM/yyyy').toISODate()
      }
      this.$refs.form.resetValidation()
    }
  },
  beforeDestroy () {
    this.initData = {}
    this.newData = {}
  },
  computed: {
    ...sync('form', [
      'initData',
      'newData'
    ]),
    ...get('form', [
      'isDirty'
    ]),
    locale () {
      return this.$i18n.locale
    }
  }
};
</script>

<style scoped>
.cardtitle {
  background-color: #7eb09f;
}
</style>